import React from 'react';
import './ConnectivityPopup.css';

/**
 * Connectivity Popup Component
 * Shows when internet connection is lost during uploads
 */
const ConnectivityPopup = ({ isVisible, isOnline, wasOffline, onRetry }) => {
  if (!isVisible) return null;

  return (
    <div className="connectivity-popup-overlay">
      <div className="connectivity-popup">
        <div className="connectivity-popup-header">
          {isOnline ? (
            <>
              <div className="connectivity-icon online">🌐</div>
              <h3>Connection Restored!</h3>
            </>
          ) : (
            <>
              <div className="connectivity-icon offline">❌</div>
              <h3>No Internet Connection</h3>
            </>
          )}
        </div>
        
        <div className="connectivity-popup-body">
          {isOnline ? (
            <p>
              Your internet connection has been restored. 
              {wasOffline && " Uploads will resume automatically."}
            </p>
          ) : (
            <p>
              Please check your internet connection. 
              Uploads have been paused and will resume automatically once you're back online.
            </p>
          )}
        </div>

        {isOnline && wasOffline && onRetry && (
          <div className="connectivity-popup-footer">
            <button 
              className="connectivity-retry-btn"
              onClick={onRetry}
            >
              Resume Uploads
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectivityPopup;
